import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useFormFields } from '../../../libs/hooksLib';
import { isNilOrEmpty } from '../../../utils/objectUtils';
import { Auth } from 'aws-amplify';
import { setRequirePasswordChange } from '../../../store/user';
import { RootState } from '../../../store';
import { showNotificationError } from '../../../libs/errorLib';

const useNewPasswordRequired = () => {
    const user = useSelector((state: RootState) => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [fields, handleFieldChange] = useFormFields({
        password: '',
        confirmPassword: '',
    });
    const [isConfirming, setIsConfirming] = useState(false);

    function validateResetForm() {
        return (
            !isNilOrEmpty(fields.password) &&
            fields.password === fields.confirmPassword
        );
    }

    const handleConfirmClick = async (
        event: React.MouseEvent<HTMLButtonElement>
    ) => {
        event.preventDefault();

        setIsConfirming(true);

        try {
            await Auth.completeNewPassword(
                user.unauthenticatedUser,
                fields.password,
                []
            );
            const request = {
                userStatus: 'CONFIRMED',
            };
            dispatch(setRequirePasswordChange());
            navigate('/login/resetSuccess');
        } catch (error) {
            showNotificationError(error.message, 'error', dispatch);
            setIsConfirming(false);
        }
    };

    return {
        fields,
        handleFieldChange,
        handleConfirmClick,
        isConfirming,
        validateResetForm,
    };
};

export default useNewPasswordRequired;
